import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useResponsiveDialog } from "../../../../../Context/ResponsiveDialogContext";

export default function StepEquity() {
    const { control, watch, setValue } = useFormContext();
    const { containerWidth } = useResponsiveDialog();
    const equity = watch('equity') || [];

    const isSmall = containerWidth > 0 && containerWidth < 500;

    const addEquityRow = () => {
        const newEquity = [...equity, { accionista: '', valor: '', porcentaje: '' }];
        setValue('equity', newEquity);
    };

    const removeEquityRow = (index) => {
        if (equity.length > 1) { // Keep at least one row
            const newEquity = equity.filter((_, idx) => idx !== index);
            setValue('equity', newEquity);
        }
    };

    return (
        <div className="p-fluid">
            {equity.map((_, idx) => (
                <div key={idx} className="formgrid grid mb-3 align-items-end">
                    <div className={`field ${isSmall ? 'col-12' : 'col-5'}`}>
                        <label htmlFor={`equity[${idx}].accionista`}>Accionista</label>
                        <Controller name={`equity[${idx}].accionista`} control={control} render={({ field }) => (
                            <InputText id={`equity[${idx}].accionista`} {...field} className="w-full" />
                        )} />
                    </div>
                    <div className={`field ${isSmall ? 'col-12' : 'col-2'}`}>
                        <label htmlFor={`equity[${idx}].valor`}>Valor</label>
                        <Controller name={`equity[${idx}].valor`} control={control} render={({ field }) => (
                            <InputText id={`equity[${idx}].valor`} {...field} className="w-full" />
                        )} />
                    </div>
                    <div className={`field ${isSmall ? 'col-12' : 'col-2'}`}>
                        <label htmlFor={`equity[${idx}].porcentaje`}>%</label>
                        <Controller name={`equity[${idx}].porcentaje`} control={control} render={({ field }) => (
                            <InputText id={`equity[${idx}].porcentaje`} {...field} className="w-full" />
                        )} />
                    </div>
                    <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                        <div className="flex gap-2">
                            <Button
                                type="button"
                                icon="pi pi-plus"
                                className="p-button-success"
                                onClick={addEquityRow}
                            />
                            {equity.length > 1 && (
                                <Button
                                    type="button"
                                    icon="pi pi-minus"
                                    className="p-button-danger"
                                    onClick={() => removeEquityRow(idx)}
                                />
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}


